import Types from "./Types";

const INITIAL_STATE = {
  records: [],
  isLoading: false,
};

const extractList = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.data?.data)) return payload.data.data;
  return [];
};

export default function attendence(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case Types.ATTENDENCE_LOADING: {
      return {
        ...state,
        isLoading: payload,
      };
    }

    case Types.LIST_ATTENDENCE_FOR_STUDENT_SUCCESS: {
      return {
        ...state,
        records: extractList(payload),
      };
    }

    case Types.LIST_ATTENDENCE_FOR_STUDENT_FAIL: {
      return {
        ...state,
        records: [],
      };
    }

    case Types.DELETE_ATTENDENCE_SUCCESS: {
      return {
        ...state,
        records: state.records.filter(
          (record) => String(record?.id) !== String(payload)
        ),
      };
    }

    default: {
      return state;
    }
  }
}
